import { RawHTML } from '@wordpress/element';

const Error = ({message=''}: {message: unknown}) => {
    return(
        <div className='dokan-delivery-time-error'>
            <div className='dokan-delivery-time-error-message'>
                {/*// @ts-ignore*/}
                <RawHTML>{message}</RawHTML>
            </div>
        </div>
    );
}

export default Error;
